import React, { useState, useEffect } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import { toast } from 'react-toastify';
import apis from '../services';


function ChangePassword() {
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const location = useLocation();
  const navigationType = useNavigationType();
  const { email, otp } = location.state || {};

  console.log(email, otp, "ChangePassword");

  useEffect(() => {
    if (!email || !otp || navigationType === 'POP') {
      navigate('/forgot-password', { replace: true });
    }
  }, [email, otp, navigate, navigationType]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error('Passwords do not match!');
      return;
    }
    setLoading(true);
    try {
      await apis.authResetPassword({ email, otp, newPassword: password });
      setTimeout(() => {
        setLoading(false);
        setSuccess(true);
      }, 800);
      toast.success('Password updated successfully!');
    } catch (error) {
      setLoading(false);
      toast.error('Failed to update password!');
    }
  };

  // Success View
  if (success) {
    return (
      <div className="login-background">
        <div className="header-container">
          <div className="header-content">
            <h2 className="header-subtitle">
              <span className="color-sp-lookna">Lookna</span>
              <br /><br />
              FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
            </h2>
          </div>
          <div className="details-borders"></div>
        </div>
        <div style={{ height: "60px" }}></div> {/* Spacing for header */}
        <div className="login-box" style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: 20, marginTop: 18 }}>
            <svg width="92" height="92" viewBox="0 0 92 92" fill="none">
              <circle cx="46" cy="46" r="44" stroke="#fff" strokeWidth="4" fill="none" />
              <path d="M30 50L42 62L64 40" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div
            style={{
              fontFamily: "'Rubik',sans-serif",
              fontWeight: 700,
              fontSize: '2rem',
              letterSpacing: 1.2,
              color: '#fff',
              marginBottom: 8,
            }}
          >
            SUCCESSFULLY
          </div>
          <div style={{ color: "#bdbec7", marginBottom: 28, fontSize: "1.1rem" }}>
            Your password has been reset successfully
          </div>
          <button
            className="login-btn"
            style={{ width: '70%', margin: '0 auto', marginBottom: 5 }}
            onClick={() => navigate('/')}
          >
            Continue
          </button>
        </div>
      </div>
    );
  }

  // Form View
  return (
    <div className="login-background">
      <div className="header-container">
        <div className="header-content">
          <h2 className="header-subtitle">
            <span className="color-sp-lookna">Lookna</span>
            <br /><br />
            FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
          </h2>
        </div>
        <div className="details-borders"></div>
      </div>
      <div style={{ height: "60px" }}></div> {/* Spacing for header */}
      <div className="login-box">
        <h2 className="login-title" style={{ textAlign: "center" }}>NEW PASSWORD</h2>
        <form className="login-form" onSubmit={handleSubmit}>
          <label className="input-label" style={{ marginTop: 10 }}>Enter New Password</label>
          <div className="input-group">
            <input
              type={passwordVisible ? 'text' : 'password'}
              placeholder="New Password"
              className="input-field"
              required
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <span className="input-icon password-toggle" onClick={() => setPasswordVisible(v => !v)}>
              {passwordVisible ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>
          <label className="input-label">Confirm Password</label>
          <div className="input-group">
            <input
              type={confirmVisible ? 'text' : 'password'}
              placeholder="Confirm Password"
              className="input-field"
              required
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
            />
            <span className="input-icon password-toggle" onClick={() => setConfirmVisible(v => !v)}>
              {confirmVisible ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>
          <button
            className="login-btn"
            type="submit"
            disabled={loading}
            style={{
              marginTop: 20,
              marginBottom: 10,
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? 'Loading...' : 'Update Password'}
          </button>
        </form>
        <div className="login-footer" style={{ textAlign: 'center', marginTop: 10 }}>
          Don't Have An Account?
          <span className="signup-link" onClick={() => navigate('/signup')}> Sign Up</span>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
